import { axios } from '@ben/api/axios';
import type { Programme } from '../models/programme';

export const getProgrammeList = async (
  employer: string | undefined
): Promise<Programme[]> => {
  const response = await axios.get<Programme[]>(
    `employers/${employer}/programmes/`
  );
  return response?.data;
};
